'use client';

import Script from 'next/script';

import { config } from '../../../context/config';

export function GlobalMedicarePixels() {
  return config.core.appEnvironment === 'prd' ? (
    <>
      <Script
        id="bing-pixels-global"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            '!function(t,e,a,n){var o,r;t[n]=t[n]||[],o=function(){var e={ti:"5280872"};e.q=t[n],t[n]=new UET(e),t[n].push("pageLoad")},(r=e.createElement(a)).src="//bat.bing.com/bat.js",r.defer=1,r.onload=r.onreadystatechange=function(){var e=this.readyState;e&&"loaded"!==e&&"complete"!==e||(o(),r.onload=r.onreadystatechange=null)},(e=e.getElementsByTagName(a)[0]).parentNode.insertBefore(r,e)}(window,document,"script","uetq");',
        }}
      />

      <Script
        id="yahoo-pixel-health-global"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            '!function(a,e,t,n){a[n]=a[n]||[],a[n].push({projectId:"10000",properties:{pixelId:"10039747"}});var o=e.createElement(t),e=(o.src="https://s.yimg.com/wi/ytc.js",o.defer=!0,o.onload=o.onreadystatechange=function(){var t,e=this.readyState,o=a[n];if(!e||"complete"==e||"loaded"==e)try{t=YAHOO.ywa.I13N.fireBeacon,a[n]=[],a[n].push=function(e){t([e])},t(o)}catch(e){}},e.getElementsByTagName(t)[0]);e.parentNode.insertBefore(o,e)}(window,document,"script","dotq");',
        }}
      />

      <Script
        id="perform-media"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            '!function(t,e,n,r,c,a){t.ctrk||((r=t.ctrk=function(){r.runner?r.runner.apply(r,arguments):r.q.push(arguments)}).q=[],(c=e.createElement(n)).async=!0,c.src="https://c.pmsrv.co/v1/analytics.js?d="+t.location.hostname,(a=e.getElementsByTagName(n)[0]).parentNode.insertBefore(c,a))}(window,document,"script"),ctrk("boot","2ad90b21-ad29-4690-9e54-7c353bfcb3f5"),ctrk("record","page-land",{dnt:!1}),ctrk("record","Retarget",{dnt:!1});',
        }}
      />

      <Script
        id="outbrain-all"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html:
            '!function(t,e){var r,a,o="00bc84599c4de44684ee6b9807c2349a36";t.obApi?t.obApi.marketerId=(a=function(t){return"[object Array]"===Object.prototype.toString.call(t)?t:[t]})(t.obApi.marketerId).concat(a(o)):((r=t.obApi=function(){r.dispatch?r.dispatch.apply(r,arguments):r.queue.push(arguments)}).version="1.1",r.loaded=!0,r.marketerId=o,r.queue=[],(a=e.createElement("script")).async=!0,a.src="//amplify.outbrain.com/cp/obtp.js",a.type="text/javascript",(t=e.getElementsByTagName("script")[0]).parentNode.insertBefore(a,t))}(window,document),obApi("track","PAGE_VIEW");',
        }}
      />
    </>
  ) : null;
}
